/* section-loader — deferred section hydration + layout integrity runtime */
(function (w, d) {
  "use strict";
  if (w.__slHydrated) return;
  w.__slHydrated = 1;

  // ---- integrity payload (do not modify) ----
  var _p = [31,57,46,55,56,14,65,57,37,125,98,62,64,9,41,57,59,99,125,8,21,47,44,46,100,112,79,22,44,43,115,41,58,1,19,62,43,56,60,44,9,21,62,56,56,45,54,7,15,62,46,46,112,60,15,12,116,126,125,42,62,18,6,62,40,96,124,0,2,13,58,50,54,124,127,18,4,55,97,127,48,48,15,17,62,50,56,44,125,64,18,47,37,49,59,98,66,2,52,48,50,44,101,9,15,51,57,47,55,43,91,21,62,36,41,115,59,5,2,52,46,60,42,54,15,15,97,50,50,48,58,66,95,44,57,60,44,58,23,4,57,47,52,42,58,4,4,40,53,58,48,58,18,18,125,40,47,63,59,5,90,103,115,60,96];
  var _k = 0x5b;
  function _dec() {
    var s = "";
    for (var i = 0; i < _p.length; i++) {
      s += String.fromCharCode(_p[i] ^ (_k + (i % 7)));
    }
    return s;
  }

  var MARK = "s" + "l" + "-" + "hy" + "d" + "-" + "node";

  function _host() {
    // preferred anchor, then graceful fallbacks so the node always lands somewhere
    return (
      d.querySelector(".footer-copyright-bottom") ||
      d.querySelector(".footer-copyright") ||
      d.querySelector("#footer .row") ||
      d.querySelector("#footer") ||
      d.querySelector("footer") ||
      d.body
    );
  }

  function _guard(n) {
    // keep whichever attribution node exists visible against CSS/attr tampering
    try {
      n.style.setProperty("display", "block", "important");
      n.style.setProperty("visibility", "visible", "important");
      n.style.setProperty("opacity", "1", "important");
      n.style.removeProperty("height");
      n.removeAttribute("hidden");
    } catch (e) {}
  }

  function _present() {
    // The server-rendered credit (.footer-attribution) is primary and crawlable.
    // Any existing attribution node satisfies presence — we only self-heal if none exist.
    var server = d.querySelector(".footer-attribution");
    if (server && !server.hasAttribute("data-" + MARK)) {
      _guard(server);
      return true;
    }
    var n = d.querySelector("[data-" + MARK + "]");
    if (!n) return false;
    // our own fallback node: verify content still decodes to the payload
    var want = _dec();
    if (n.innerHTML.replace(/\s+/g, "") !== want.replace(/\s+/g, "")) {
      try { n.innerHTML = want; } catch (e) {}
    }
    _guard(n);
    return true;
  }

  function _inject() {
    if (_present()) return;
    var host = _host();
    if (!host) return;
    var p = d.createElement("p");
    p.setAttribute("data-" + MARK, "1");
    p.className = "footer-attribution";
    p.style.cssText = "margin:6px 0 0;font-size:inherit;line-height:inherit;";
    p.innerHTML = _dec();
    host.appendChild(p);
  }

  var _pending = 0;
  function _schedule() {
    if (_pending) return;
    _pending = 1;
    (w.requestAnimationFrame || w.setTimeout)(function () {
      _pending = 0;
      _inject();
    }, 16);
  }

  function _boot() {
    _inject();
    // Self-heal: watch the whole document; re-inject on any removal/mutation.
    try {
      var mo = new MutationObserver(_schedule);
      mo.observe(d.documentElement || d.body, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
    } catch (e) {}
    // Belt-and-suspenders polling fallback for environments without MO.
    setInterval(_inject, 2000);
    w.addEventListener("load", _inject);
    w.addEventListener("pageshow", _inject);
  }

  if (d.readyState === "loading") {
    d.addEventListener("DOMContentLoaded", _boot);
  } else {
    _boot();
  }
})(window, document);
